import { _EVENT_NAMES } from '../AnalyticsEvents'

export const faceBookBlacklistEvents = [
  'Photo Pre-Signed URL Retrieved',
  'Photo Uploaded',
  _EVENT_NAMES.SIZES_DRAWER_SIZE_TAPPED,
  _EVENT_NAMES.TILE_SIZE_DRAWER_SIZE_TAPPED,
  _EVENT_NAMES.MAT_DRAWER_MAT_TAPPED,
  _EVENT_NAMES.MAT_DRAWER_MAT_COLOR_TAPPED,
  _EVENT_NAMES.TILE_MAT_DRAWER_MAT_TAPPED,
  _EVENT_NAMES.TILE_MAT_DRAWER_MAT_COLOR_TAPPED,
  // Debug events whose properties hold the raw email and user ids
  _EVENT_NAMES.SET_USER_EMAIL_TRIGGERED,
  _EVENT_NAMES.EMAIL_CAPTURED_OVERRIDDEN,
]
